import gpio from "gpio";
import I2C from "i2c";

const I2C_DEVICE = "/dev/i2c-1";

function sleep(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

class EZO {
  constructor(chip_address) {
    this.__chip_address = chip_address;
  }
  async initialize() {
    this.__bus = new I2C();
    await this.__bus.open(I2C_DEVICE, this.__chip_address);
  }
  async command(cmd) {
    await this.__bus.write( new TextEncoder().encode(cmd) );
    do {
	    await sleep(100);
	    var uint8array = new Uint8Array( await this.__bus.read(31) );
	    /* Pending – the request is still being processed.  Ensure that you have waited the minimum time to guarantee a response */
    } while (uint8array[0]==254);
    
    switch (uint8array[0]) {
      case 255: /*No Data – there is no pending request, so there is no data to return from the circuit */
        return(undefined);
      case   2: /* Failed – the request failed */
        throw "Syntax error";
      case   1: /* Success – the requested information is ready */
        uint8array = uint8array.subarray(1);
        uint8array = uint8array.map(v => v &= ~0x80);
        uint8array = uint8array.filter(v => v != 0);
        return( String.fromCharCode.apply(null, uint8array) );
      default:
        throw "Device error";
    }
  }
}

export default EZO;